import {
  eventPluginTest,
  storagePlugin,
  eventPluginMultiSw,
  immediateTrue,
  eventDialogClick,
  multiStoragePlugin,
  storageDialogPlugin,
  changeEventLayoutScroll
} from "./eventPluginTest"
export default {
  eventPluginTest,
  storagePlugin,
  eventPluginMultiSw,
  immediateTrue,
  eventDialogClick,
  multiStoragePlugin,
  storageDialogPlugin,
  changeEventLayoutScroll
}
